import React from 'react'

// STYLES
import styled from 'styled-components'

const SubTitle = ({color, text, className}) => <h5 className={className}>{text}</h5>

const SubTitleWithStyles = styled(SubTitle)`
    color: ${(props) => (props.color ? props.color : '#66666')};
    max-width: 744px;
    font-family: "Source Sans Pro";
    font-size: 18px;
    line-height: 23px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    font-weight: 400;
    margin-top: 0px;
`

export default SubTitleWithStyles



// WEBPACK FOOTER //
// ./src/components/subtitle/subtitle.component.js